import { TOGGLE_EMAIL_CONFIRMATION_DIALOG } from './types'

const toggleEmailConfirmationDialog = toggle => ({
  type: TOGGLE_EMAIL_CONFIRMATION_DIALOG,
  payload: toggle
})

export { toggleEmailConfirmationDialog }
